import { createContext, useContext, useState, useEffect, useCallback } from 'react'
import axios from 'axios'
import { resolveCity } from '../utils/cityMapper'
import { isAlertVehicle } from '../utils/alertUtils'

const VehicleContext = createContext(null)

const API_URL = `${process.env.REACT_APP_HOST_API_URL}/vehicle/tracking/merged-vehicle-status`
const REFRESH_INTERVAL = 30

export function VehicleProvider({ children }) {
  const [vehicles, setVehicles] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [lastUpdated, setLastUpdated] = useState(null)
  const [countdown, setCountdown] = useState(REFRESH_INTERVAL)

  const load = useCallback(async () => {
    try {
      setError(null)
      const { data } = await axios.get(API_URL)
      const enriched = (data?.data || []).map(v => ({ ...v, city: resolveCity(v.lt, v.lng) }))
      setVehicles(enriched)
      setLastUpdated(new Date())
      setCountdown(REFRESH_INTERVAL)
    } catch {
      setError('Failed to fetch vehicle data. Check network or API.')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    load()
    const interval = setInterval(load, REFRESH_INTERVAL * 1000)
    return () => clearInterval(interval)
  }, [load])

  useEffect(() => {
    const tick = setInterval(() => setCountdown(c => (c > 0 ? c - 1 : REFRESH_INTERVAL)), 1000)
    return () => clearInterval(tick)
  }, [])

  const alerts = vehicles.filter(isAlertVehicle)

  return (
    <VehicleContext.Provider value={{ vehicles, loading, error, lastUpdated, countdown, load, alerts }}>
      {children}
    </VehicleContext.Provider>
  )
}

export const useVehicles = () => useContext(VehicleContext)
